import styled, { css } from "styled-components";

export default styled.div`
  overflow: hidden;
  width: 100%;
  height: 100%;
  ${(props) => (props.background ? `background: ${props.background};` : "")}

  & > div {
    min-height: 100%;

    & > div {
      ${({ hasMarginBottom }) =>
        hasMarginBottom &&
        css`
          padding-bottom: 12px;
        `};
    }
  }
`;
